module.exports = __webpack_public_path__ + "img/treasuries.a114fa16.svg";